"use client";
import React, { createContext, useContext } from 'react'
import { FieldValues } from 'react-hook-form'
import * as yup from 'yup'

// Form Context 接口
export interface FormContextValue {
  /** yup验证schema，用于自动推断FormItem的required状态 */
  schema?: yup.ObjectSchema<FieldValues>
  /** 是否为查看模式 */
  isView?: boolean
  /** 是否为查询模式 */
  isQuery?: boolean
}

// 创建 Form Context
const FormContext = createContext<FormContextValue>({
  isView: false,
})

// Form Context Provider 组件
export const FormContextProvider: React.FC<{
  value: FormContextValue
  children: React.ReactNode
}> = ({ value, children }) => {
  return (
    <FormContext.Provider value={value}>
      {children}
    </FormContext.Provider>
  )
}

// 使用 Form Context 的 Hook
export const useFormSchemaContext = () => {
  const context = useContext(FormContext)
  return context
}

export default FormContext